






















































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  CustomerModel,
} from "../shared/models/vCustomer";
import { Country } from "../shared/models/country";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import DateField from "@/components/misc/DateField.vue";
import _ from "lodash";
import brokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import { Notification } from "@/store/modules/notifications";
import { AxiosResponse } from "axios";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";

@Component({ components: { RightDrawer, DateField } })
export default class CustomerFormMobile extends Vue {
  @Prop({ default: null }) customerId!: number | null;
  @Prop({ default: false }) open!: boolean;
  @Prop({ default: undefined }) prefill?: CustomerModel;

  fkey = 0;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
    }

    if (fresh && this.customerId) {
      await this.loadCustomer();
      this.initialCustomer = new CustomerModel();
    } else {
      this.customer = new CustomerModel();

      if (this.prefill) {
        this.customer = {
          ...this.customer,
          ...this.prefill,
        };
      }

      this.initialCustomer = _.cloneDeep(this.customer);
    }
  }

  get radioGroupRow() {
    return window.innerWidth > 370;
  }

  @Action("codebooks/refreshIdentificationDocumentTypes")
  refreshIdentificationDocumentTypes?: () => Promise<void>;
  @Getter("codebooks/identificationDocumentTypes")
  identificationDocumentTypes?: IdentificationDocumentType[];

  @Getter("language/language") language?: string;
  @Getter("codebooks/countries") _countries?: Country[];
  get countries() {
    if (!this._countries) {
      return [];
    }

    return this._countries;
  }

  loading = false;
  saving = false;

  initialCustomer: CustomerModel = new CustomerModel();
  customer: CustomerModel = new CustomerModel();

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading && !this.saving;
  }

  rules = {};

  mounted() {
    this.setUpRules();
    if (this.countries && this.countries.length == 0) {
      this.$store.dispatch("codebooks/refreshCountries");
    }
    if (
      !this.identificationDocumentTypes ||
      this.identificationDocumentTypes.length == 0
    ) {
      this.refreshIdentificationDocumentTypes?.();
    }
  }

  setUpRules() {
    this.rules = {
      Required: [(value: any) => !!value || this.$t("Validation.Required")],
      Name: [
        (value: string) =>
          !value ||
          value.length <= 50 ||
          this.$t("Validation.MaxLength", { count: 50 }),
      ],
      Email: [
        (value: string) =>
          !value ||
          value.length <= 100 ||
          this.$t("Validation.MaxLength", { count: 100 }),
        (value: string) =>
          !value ||
          /^$|.+@.+\..+/.test(value) || this.$t("Validation.EmailFormat"),
      ],
      LegalEntityName: [
        (value: string) =>
          !value ||
          value.length <= 200 ||
          this.$t("Validation.MaxLength", { count: 200 }),
      ],
      BusinessId: [
        (value: string) =>
          !value ||
          value.length <= 20 ||
          this.$t("Validation.MaxLength", { count: 20 }),
      ],
      TelephoneNumber: [
        (value: string) =>
          !value ||
          value.length <= 100 ||
          this.$t("Validation.MaxLength", { count: 100 }),
      ],
      StreetName: [
        (value: string) =>
          !value ||
          value.length <= 100 ||
          this.$t("Validation.MaxLength", { count: 100 }),
      ],
      HouseNumber: [
        (value: string) =>
          !value ||
          value.length <= 10 ||
          this.$t("Validation.MaxLength", { count: 10 }),
      ],
      PostalCode: [
        (value: string) =>
          !value ||
          value.length <= 10 ||
          this.$t("Validation.MaxLength", { count: 10 }),
      ],
      City: [
        (value: string) =>
          !value ||
          value.length <= 50 ||
          this.$t("Validation.MaxLength", { count: 50 }),
      ],
      IdentificationDocumentNumber: [
        (value: string) =>
          !value ||
          value.length <= 50 ||
          this.$t("Validation.MaxLength", { count: 50 }),
      ],
      Remarks: [
        (value: string) =>
          !value ||
          value.length <= 500 ||
          this.$t("Validation.MaxLength", { count: 500 }),
      ],
    };
  }

  loadCustomer() {
    this.loading = true;
    Vue.axios.get<any>("/customers/" + this.customerId).then((res) => {
      this.customer = res.data;

      if (res.data.dateOfBirth) {
        let value = new Date(res.data.dateOfBirth);
        value = new Date(
          Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())
        );
        this.customer.dateOfBirth = value.toISOString().substring(0, 10);
      }
      
      this.initialCustomer = _.cloneDeep(this.customer);

      this.loading = false;
    });
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  submit() {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    this.submitToServer({ ...this.customer }, []);
  }

  submitToServer(customer: CustomerModel, overrides: string[]) {
    const handleCodes = [
      "Customer.BusinessIdNotUniqueInCountry",
      "Customer.IdentificationDocumentNotUniqueInCountry",
      "Customer.EmailNotUnique",
    ];
    const adapter = brokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const confirmOverrideNotification = (
      x: AxiosResponse & { handled: string[] }
    ) =>
      this.$store.dispatch("showNotification", {
        color: "warning",
        message:
          // prettier-ignore
          `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
        timeout: 30000,
        actions: [
          {
            text: this.$t("Yes"),
            fun: () => {
              this.submitToServer(customer, x.handled);
              return true;
            },
          },
          { text: this.$t("Cancel"), fun: () => true },
        ],
      } as Notification);

    const handleSuccess = (
      messageTextResource: string,
      mode: "post" | "put"
    ) => (res: any) => {
      this.customer =
        mode === "post" ? { ...customer, id: res.data } : customer;
      this.initialCustomer = _.cloneDeep(this.customer);

      this.$store.dispatch("showNotification", {
        color: "success",
        message: this.$t("Customer.SaveSuccess"),
        timeout: 5000,
      });

      this.$emit("update:open", false);
      this.$emit("saved", this.customer);
    };

    const isOverriding = overrides.length !== 0;

    const mode: "post" | "put" =
      customer.id && customer.id !== 0 ? "put" : "post";
      this.saving = true;
    return Vue.axios[mode](
      `/customers`,
      { ...customer, overrideRules: overrides },
      isOverriding ? undefined : { adapter }
    )
      .then(handleSuccess("Customer.SaveSuccess", mode))
      .finally(() => {
        this.saving = false;
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          confirmOverrideNotification(x);
        }
      });
  }

  formatDate(date: string | Date) {
    if (!date) return null;
    return this.$d(new Date(date));
  }
  parseDate(date: string) {
    if (!date) return null;

    const [month, day, year] = date.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  get dateOfBirth() {
    if (this.customer.dateOfBirth) {
      return this.$d(new Date(this.customer.dateOfBirth));
    }

    return "";
  }
}
